const parseJson = async response => {
  try {
    return await response.json()
  } catch (error) {
    return Promise.resolve()
  }
}

export default parseJson
